type SortableItem<T> = { sortOrder?: number; item: T };
type SortableGroup<T> = { sortOrder?: number; items: T[] };

/**
 * Merges standard sidebar sub-items with client-injected groups (NAF apps,
 * AOIOB) on a shared `sortOrder` scale.
 *
 * A standard item without a `sortOrder` uses its index. A group without one
 * goes last, preserving the historical "append" behavior. On ties, standard
 * items come before groups, and groups keep the order they were passed in.
 */
export const mergeSidebarGroups = <T>(
  standard: SortableItem<T>[],
  groups: SortableGroup<T>[],
): T[] => {
  const entries = [
    ...standard.map(({ sortOrder, item }, index) => ({
      key: [sortOrder ?? index, 0, index],
      items: [item],
    })),
    ...groups.map(({ sortOrder, items }, index) => ({
      key: [sortOrder ?? Infinity, 1, index],
      items,
    })),
  ];

  entries.sort(
    (a, b) => a.key[0] - b.key[0] || a.key[1] - b.key[1] || a.key[2] - b.key[2],
  );

  return entries.flatMap(({ items }) => items);
};
